import React from 'react';
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { css } from '@emotion/core';
import { useSelector } from 'react-redux';
import { Box } from 'src/components/Box';
import { CardSelectable } from 'src/components/CardSelectable';
import { Icon } from 'src/components/Icon';
import { IconName } from 'src/components/Icon/Icon.types';
import { Text } from 'src/components/Text';
import { globalUiSelectors } from 'src/store/globalUi/selectors';
import { PersistentAppKind } from 'src/orchd-client';
import { FormattedMessage } from 'react-intl';
import { messages } from 'src/messages';

interface Props {
  changeRuntime: (runtime: PersistentAppKind) => void;
  currentRuntime?: PersistentAppKind;
  showNoneOption: boolean;
}

export const runtimeIcons: Record<PersistentAppKind, IconName> = {
  [PersistentAppKind.generic]: 'code_24',
  [PersistentAppKind.nodejs]: 'node js thin',
  [PersistentAppKind.tomcat]: 'code_24',
  [PersistentAppKind.laravel]: 'laravel',
  [PersistentAppKind.php]: 'php2',
  [PersistentAppKind.openclaw]: 'openclaw',
  [PersistentAppKind.django]: 'code_24',
};

export const runtimeLabels: Record<PersistentAppKind, string> = {
  [PersistentAppKind.generic]: 'Custom',
  [PersistentAppKind.nodejs]: 'Node.js',
  [PersistentAppKind.tomcat]: 'Tomcat',
  [PersistentAppKind.laravel]: 'Laravel',
  [PersistentAppKind.php]: 'PHP',
  [PersistentAppKind.openclaw]: 'Openclaw',
  [PersistentAppKind.django]: 'Django',
};

const filteredAppKinds = Object.values(PersistentAppKind)
  .filter((val) => ![PersistentAppKind.openclaw, PersistentAppKind.django, PersistentAppKind.tomcat].includes(val))
  .sort((a, b) => {
    if (a === PersistentAppKind.nodejs) return -1;
    if (b === PersistentAppKind.nodejs) return 1;

    return a.localeCompare(b);
  });

export const SelectableRuntimes = ({ changeRuntime, currentRuntime, showNoneOption }: Props) => {
  const darkMode = useSelector(globalUiSelectors.darkMode);
  return (
    <Box d="row">
      {showNoneOption && (
        <Box
          d="row"
          css={css`
            width: 100px;
            margin-right: 12px;
            margin-bottom: 8px;
          `}
        >
          <CardSelectable
            selected={!currentRuntime}
            onClick={() => changeRuntime(undefined)}
            noShadow
            borderColor={darkMode ? 'grey40' : 'grey10'}
            padding="sm"
          >
            <Box d="row" a="center">
              <Text size="sm">
                <FormattedMessage {...messages.none} />
              </Text>
            </Box>
          </CardSelectable>
        </Box>
      )}

      {filteredAppKinds.map((kind) => (
        <Box
          d="row"
          css={css`
            width: 100px;
            margin-right: 12px;
            margin-bottom: 8px;
          `}
        >
          <CardSelectable
            selected={kind === currentRuntime}
            onClick={() => changeRuntime(kind)}
            noShadow
            borderColor={darkMode ? 'grey40' : 'grey10'}
            padding="sm"
          >
            <Box d="row" a="center">
              {kind !== undefined && <Icon name={runtimeIcons[kind]} marginRight="sm" />}
              <Text size="sm">{runtimeLabels[kind]}</Text>
            </Box>
          </CardSelectable>
        </Box>
      ))}
    </Box>
  );
};
